
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 0C4.473 0 0 4.473 0 10c0 1.754.457 3.467 1.326 4.978L.038 18.979a.781.781 0 00.983.983l4.001-1.288A9.978 9.978 0 0010 20c5.527 0 10-4.473 10-10S15.527 0 10 0zm0 18.438a8.412 8.412 0 01-4.466-1.279.782.782 0 00-.654-.081l-2.888.93.93-2.888a.782.782 0 00-.081-.654A8.414 8.414 0 011.562 10c0-4.652 3.786-8.438 8.438-8.438 4.652 0 8.438 3.786 8.438 8.438 0 4.652-3.786 8.438-8.438 8.438z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.49 14.96L.18 19.026a.631.631 0 00.795.795l4.064-1.31.058.034A9.827 9.827 0 0010 19.85 9.845 9.845 0 0019.85 10 9.845 9.845 0 0010 .15 9.845 9.845 0 00.15 10a9.82 9.82 0 001.306 4.903l.033.058zm1.432.16a.782.782 0 00-.081-.654A8.414 8.414 0 011.562 10c0-4.652 3.786-8.438 8.438-8.438 4.652 0 8.438 3.786 8.438 8.438 0 4.652-3.786 8.438-8.438 8.438a8.412 8.412 0 01-4.466-1.279.782.782 0 00-.654-.081l-2.888.93.93-2.888zm2.532 2.166a.632.632 0 00-.528-.065L1.76 18.24l1.02-3.167a.632.632 0 00-.065-.528A8.564 8.564 0 011.413 10c0-4.735 3.852-8.588 8.587-8.588 4.735 0 8.587 3.853 8.587 8.588 0 4.735-3.852 8.587-8.587 8.587a8.563 8.563 0 01-4.546-1.3zM0 10C0 4.473 4.473 0 10 0s10 4.473 10 10-4.473 10-10 10a9.978 9.978 0 01-4.978-1.326l-4.001 1.288a.781.781 0 01-.983-.983l1.288-4.001A9.977 9.977 0 010 10z","fill":"#353231"}})])
          )
        }
      }
    